import { render, staticRenderFns } from "./newGame.vue?vue&type=template&id=1564fdcc&scoped=true"
import script from "./newGame.vue?vue&type=script&lang=js"
export * from "./newGame.vue?vue&type=script&lang=js"
import style0 from "./newGame.vue?vue&type=style&index=0&id=1564fdcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564fdcc",
  null
  
)

export default component.exports